export const styles = () => ({
  '.MuiFormControlLabel-labelPlacementEnd': {
    marginLeft: '0',
    marginRight: 'auto',
    '.dn-checkbox-wrapper': {
      marginRight: '5px',
    },
  },
  '.MuiFormControlLabel-labelPlacementStart': {
    marginLeft: 'auto',
    marginRight: '0',
    '.dn-checkbox-wrapper': {
      marginLeft: '4px',
    },
  },
  '.MuiCheckbox-root': {
    padding: '4px',
    '.MuiSvgIcon-root': {
      fontSize: '18px',
    },
  },
  '.MuiFormControlLabel-root > .MuiTypography-body1': {
    fontSize: '12px',
    lineHeight: '1.4',
    color: '#6A6A6A',
  },
  '&.dn-error': {
    '.MuiFormControlLabel-root > .MuiTypography-body1': {
      color: '#d32f2f !important',
      fontWeight: 700,
      a: {
        color: 'inherit',
        textDecoration: 'underline',
      },
    },
    svg: {
      stroke: '#d32f2f !important',
    },
  },
  '.MuiCheckbox-root.MuiCheckbox-indeterminate': {
    color: 'rgba(40, 69, 210, 0)',
  },
});
